import React, { useEffect, useState, useRef, Suspense, memo } from "react";
import { useObjectStore } from "../zustand/objects";
import LayerListItem from "./LayerListItem";
import {isMobile} from 'react-device-detect';
import debounce from 'lodash.debounce';
import LockIcon from '@mui/icons-material/Lock';
// MANTINE
import { Accordion, useMantineTheme, Badge, Card, Button, Image, Text, Group, ActionIcon } from '@mantine/core';

const CubeIcon = ({borderColour}) => {

const strokeWidth = 35

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M245.637 59.0793C252.078 55.5054 259.908 55.5076 266.347 59.0852L447.681 159.829C454.453 163.592 458.654 170.731 458.654 178.478V333.521C458.654 341.269 454.453 348.407 447.681 352.17L266.354 452.91C259.911 456.49 252.076 456.49 245.633 452.911L64.2935 352.17C57.5208 348.407 53.3203 341.269 53.3203 333.521V178.341C53.3203 170.59 57.5253 163.448 64.3037 159.687L245.637 59.0793Z" 
      stroke={borderColour} strokeWidth={strokeWidth} />
      <path d="M255.992 278.511V458.677" stroke={borderColour} strokeWidth={strokeWidth} />
      <path d="M255.985 278.507L53.3203 165.917" stroke={borderColour} strokeWidth={strokeWidth} />
      <path d="M458.661 165.917L255.992 278.507" stroke={borderColour} strokeWidth={strokeWidth} />
    </svg>
  )
}


const LayerList = ({mobile}) => {
  const {
    objectsAreLoaded,
    artboards,
    currentObjectArtboard,
    addToGroupedObjects,
    removeFromGroupedObjects,
    grouping,
    setGrouping,
    selectedObjectID,
    updateObjectSelected,
    groupedObjects,
    arrangeUndoRedo,
    textModalOpen,
    removeObject,
    editingObjectTitle
  } = useObjectStore();

  const theme = useMantineTheme();


const checkboxClick = (e) => {
  e.currentTarget.checked ? addToGroupedObjects(e.target.value) : removeFromGroupedObjects(e.target.value) 
}

const handleGroupClick = () => {
  setGrouping()
} 

const list = useRef()

const [value, setValue] = useState(null);


useEffect(() => {
  if (objectsAreLoaded === true) {
    const element = document.getElementById(selectedObjectID);
    const table = document.getElementById('table');
    if (selectedObjectID !== '0' && selectedObjectID !== null) { 
      element.scrollIntoView({ behavior: 'smooth' }) 
    } 
    else {
      table.scrollTo({top:0})}
    }
},[selectedObjectID]);

const closeListItem = () => {
  updateObjectSelected('0');
};

  // KEYBOARD OBJECT FUNCTIONS
  function handleKeyDown(event) {
    if (event.repeat) { return }
    if (event.key === 'Backspace') { 
      if (textModalOpen === false) {
        if (!editingObjectTitle) {
          // send current state to undoActions
          arrangeUndoRedo({
            updateType: "objectRemove",
            artboard: currentObjectArtboard,
            objectID: selectedObjectID,
            undo: false,
            data: artboards[currentObjectArtboard].find((x) => x.id === selectedObjectID)
          })
          // send update to zustand
        removeObject({ currentObjectArtboard: currentObjectArtboard, id:selectedObjectID, undo: false })
        updateObjectSelected('0')}}
    } 
    else if (event.key === 'Escape') {
      closeListItem()
    }
    else if (event.key === 'Tab') { 
      
      const index = artboards[currentObjectArtboard].findIndex(obj => obj.id === selectedObjectID);
      const arrayLength = artboards[currentObjectArtboard].length
      let nextIndex;
      if (index === arrayLength - 1) { // Reached the end, cycle back to the beginning
        nextIndex = 0;
      } else {
        nextIndex = index + 1; // Move to the next object
      }  
      (textModalOpen === false) && updateObjectSelected(artboards[currentObjectArtboard][nextIndex].id);
    }
  }

  // KEYBOARD OBJECT FUNCTIONS
  function handleKeyDownNotSelected(event) {
    if (event.repeat) { return }
    if (event.key === 'Tab') {    
      (textModalOpen === false) && updateObjectSelected(artboards[currentObjectArtboard][0].id);
    }
  } 

  useEffect(() => {
      if (!artboards || !currentObjectArtboard) return;
    if (artboards[currentObjectArtboard].length > 0) {
      if (selectedObjectID === '0') {
        document.addEventListener('keydown', handleKeyDownNotSelected)
      }
      else {
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown);
      } 
      return () => document.removeEventListener('keydown', handleKeyDownNotSelected)
    }
       
  },[objectsAreLoaded, selectedObjectID, textModalOpen])

  if (!objectsAreLoaded) {
    return <div></div>;
  } else { 
    return ( 
      // <ul id='table' ref={list} style={{paddingLeft: 0, paddingBottom:5, overflow: 'scroll',  listStyle:"none", marginTop: "0px", marginBottom: "0px", overflowX: "hidden", overflowY: "auto"}}>
      <ul id='table' ref={list} style={{ listStyle:"none", height:'100%', paddingBottom:10, paddingLeft:0, paddingRight:0}}>
        <Accordion variant="separated" radius={'lg'} value={selectedObjectID} onChange={e => updateObjectSelected(e)} pb={10} >
          {/* <Divider my="sm"/> */}
          <Group justify="space-between">
          <Text fw={1000} size="xs" c="dimmed" mb="sm">
            SCENE ELEMENTS</Text>
            <Badge size="sm" mb="sm" variant="light" color={'gray'}>{artboards[currentObjectArtboard].length ? artboards[currentObjectArtboard].length : 0} OBJECTS</Badge></Group>

        {artboards && currentObjectArtboard && artboards[currentObjectArtboard].map((objects, i) => (
          <Suspense key={objects.id} fallback={null}>
          <li>
          <Accordion.Item value={objects.id} mb={10}
          style={{
              borderWidth: 2,
              borderColor: selectedObjectID === objects.id ? theme.colors.primary[5] : theme.colors.secondary[3],
              backgroundColor: selectedObjectID === objects.id ? theme.colors.primary[0] : theme.colors.neutral[0],
              boxShadow: selectedObjectID === objects.id && '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06)', // shadow-md
          }}>
          <Accordion.Control icon={objects.isLocked && <LockIcon fontSize='small'/>}>
            <Group gap={10}>
            <CubeIcon borderColour={selectedObjectID === objects.id ? theme.colors.primary[5] : theme.colors.secondary[4]}/>
            <Text size="sm">
              {objects.objectTitle}</Text></Group></Accordion.Control>
            <div id={objects.id} style={{display: "flex"}}>{grouping && objects.id !== "camera" && <input value={objects.id} type="checkbox" style={{cursor: "pointer", marginRight: 5}} onChange={(e) => checkboxClick(e)} checked={groupedObjects.includes(objects.id)}/>}
            <Accordion.Panel>
            {objects.id !== 'camera' ?
            
            selectedObjectID === objects.id && <LayerListItem
              key={objects.id}
              id={objects.id} 
              position={objects.position}
              rotation={objects.rotation} 
              destination={objects.destination}
              scale={objects.scale} 
              category={objects.category}
              object={objects.object}
              transformMode={objects.transformMode}
              content={objects.content}
              textKind={objects.textKind}
              colour={objects.colour} 
              bGColour={objects.bGColour}
              pose={objects.pose}
              title={objects.objectTitle}
              texture={objects.imageTexture}
              isLocked={objects.isLocked}
              matrix={objects.matrixState}
              figmaID={objects.figmaID}
              figmaURL={objects.figmaURL}
              figmaSize={objects.figmaSize}
              image={objects.image}
              imageSize={objects.imageSize}
              curved={objects.curved}
              curveAmount={objects.curveAmount}
              uploadedURL={objects.uploadedURL}
            />
            : ''}
            </Accordion.Panel>
            </div>
            </Accordion.Item>
          </li>
          </Suspense>
        ))}
      </Accordion>
      </ul>
    );
  }
};

export default LayerList;
